import { useMemo } from 'react';

import capitalize from 'lodash/capitalize';

import { useI18n } from '@change-corgi/core/react/i18n';

type Result = ModelHookResult<{
	channelName: string;
}>;

export function useShareFeedItem(channel: string): Result {
	const { translate } = useI18n();
	const channelNameMapping: Record<string, string> = useMemo(
		() => ({
			whatsapp: 'WhatsApp',
			facebookmessenger: 'facebookMessenger',
			facebook_messenger: 'Facebook Messenger',
			facebookmessage: 'Facebook Messenger',
			facebook_message: 'Facebook Messenger',
			sms: 'SMS',
			vk: 'VK',
			copylink: translate('fe.components.psf.share.share_feed.copy_link_medium'),
			mobileNativeShare: translate('fe.components.psf.share.share_feed.copy_link_medium'),
		}),
		[translate],
	);

	return {
		data: {
			channelName: useMemo(() => channelNameMapping[channel] || capitalize(channel), [channelNameMapping, channel]),
		},
	};
}
